import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelRadio as _vModelRadio, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f4c6e50"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page" };
const _hoisted_2 = { class: "card" };
const _hoisted_3 = { class: "card-header" };
const _hoisted_4 = { class: "card-body" };
const _hoisted_5 = { class: "field" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "brand" }, [
    /*#__PURE__*/ _createTextVNode("ブランド"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    selected: ""
}, "未選択", -1));
const _hoisted_8 = ["value"];
const _hoisted_9 = { class: "field" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "coupon_name" }, [
    /*#__PURE__*/ _createTextVNode("クーポン名"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_11 = { class: "field" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "target_product" }, [
    /*#__PURE__*/ _createTextVNode("対象商品"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    selected: ""
}, "未選択", -1));
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "field" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "detailed_description" }, [
    /*#__PURE__*/ _createTextVNode("詳細説明"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_17 = {
    ref: "editorContainer",
    class: "quill-container"
};
const _hoisted_18 = { style: { "margin-top": "8px", "font-size": "13px", "color": "#666" } };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_20 = { class: "field" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "discount" }, [
    /*#__PURE__*/ _createTextVNode("割引額・割引率"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_22 = { class: "discount-row" };
const _hoisted_23 = { class: "radio-group" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "discount_unit_yen" }, "￥", -1));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "discount_unit_%" }, "%", -1));
const _hoisted_26 = { class: "field" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "term_of_use" }, [
    /*#__PURE__*/ _createTextVNode("利用条件"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_28 = { class: "field" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "expiration_date" }, [
    /*#__PURE__*/ _createTextVNode("有効期限"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_30 = { class: "field" };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "available_times" }, [
    /*#__PURE__*/ _createTextVNode("利用可能回数"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_32 = ["value"];
const _hoisted_33 = { class: "button-row" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Title, {
                    msg: "クーポン生成",
                    submsg: "Coupon Generation"
                })
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("select", {
                        id: "brand_id",
                        name: "brand_id",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.form.brandId) = $event))
                    }, [
                        _hoisted_7,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.brandInfo, (b) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: b.brandId,
                                value: b.brandId
                            }, _toDisplayString(b.brandName), 9, _hoisted_8));
                        }), 128))
                    ], 512), [
                        [_vModelSelect, $data.form.brandId]
                    ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "point_name",
                        name: "point_name",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.form.couponName) = $event))
                    }, null, 512), [
                        [_vModelText, $data.form.couponName]
                    ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createElementVNode("select", {
                        id: "target_product",
                        name: "target_product",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.form.targetProductId) = $event))
                    }, [
                        _hoisted_13,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.productInfo, (p) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: p.targetProductId,
                                value: p.targetProductId
                            }, _toDisplayString(p.targetProduct), 9, _hoisted_14));
                        }), 128))
                    ], 512), [
                        [_vModelSelect, $data.form.targetProductId]
                    ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, null, 512),
                    _createElementVNode("div", _hoisted_18, [
                        _createTextVNode(" HTML 全体の文字数: " + _toDisplayString($data.htmlLength) + " 字 ", 1),
                        _hoisted_19,
                        _createTextVNode(" プレーンテキストの文字数: " + _toDisplayString($data.textLength) + " 字 ", 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "discount",
                            name: "discount",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.form.discount) = $event))
                        }, null, 512), [
                            [_vModelText, $data.form.discount]
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                id: "discount_unit_yen",
                                name: "discount_unit",
                                value: "0",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($data.form.discountUnit) = $event))
                            }, null, 512), [
                                [_vModelRadio, $data.form.discountUnit]
                            ]),
                            _hoisted_24,
                            _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                id: "discount_unit_%",
                                name: "discount_unit",
                                value: "1",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($data.form.discountUnit) = $event))
                            }, null, 512), [
                                [_vModelRadio, $data.form.discountUnit]
                            ]),
                            _hoisted_25
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "term_of_use",
                        name: "term_of_use",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($data.form.termOfUse) = $event))
                    }, null, 512), [
                        [_vModelText, $data.form.termOfUse]
                    ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "expiration_date",
                        name: "expiration_date",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (($data.form.expirationDate) = $event))
                    }, null, 512), [
                        [_vModelText, $data.form.expirationDate]
                    ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _withDirectives(_createElementVNode("select", {
                        id: "available_times",
                        name: "available_times",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($data.form.availableTimes) = $event))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.times, (n) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: n,
                                value: n
                            }, _toDisplayString(n), 9, _hoisted_32));
                        }), 128))
                    ], 512), [
                        [_vModelSelect, $data.form.availableTimes]
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                    class: "btn-setting",
                    onClick: _cache[9] || (_cache[9] =
                        //@ts-ignore
                        (...args) => ($options.handleSetting && $options.handleSetting(...args)))
                }, "クーポン生成")
            ])
        ])
    ]));
}
